@let apiResponse = data();
@if (apiResponse) {
  <p-table
    [value]="apiResponse.data"
    [loading]="puService.datasource.isLoading()"
    [showGridlines]="true"
    [scrollable]="true"
    scrollHeight="flex"
    stripedRows
    class="p-datatable-sm lp-table"
    selectionMode="single"
    [metaKeySelection]="true"
    (onRowSelect)="onRowSelect($event)"
    dataKey="id"
    [lazy]="true"
    [lazyLoadOnInit]="false"
    (onLazyLoad)="onLazyLoad($event)"
    sortField="udbyderNavn"
    [sortOrder]="1"
    [paginator]="true"
    [rows]="100"
    [totalRecords]="apiResponse.totalRowCount"
    [showJumpToPageDropdown]="true"
    letKeepScrollPosition>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="udbyderNavn">
          Navn
          <p-sortIcon field="udbyderNavn" />
        </th>
        <th pSortableColumn="pengeinstitut.hovedRegNr" style="width: 120px">
          Regnr
          <p-sortIcon field="pengeinstitut.hovedRegNr" />
        </th>
        <th pSortableColumn="pensionsInfoUdbyderNavnNr" style="width: 120px">
          NavnNr
          <p-sortIcon field="pensionsInfoUdbyderNavnNr" />
        </th>
        <th pSortableColumn="p41TilladtFraLeverandoer" style="width: 140px">
          §41 tilladt
          <p-sortIcon field="p41TilladtFraLeverandoer" />
        </th>
      </tr>
    </ng-template>
    <ng-template [appTableRow]="apiResponse.data" pTemplate="body" let-item>
      <tr [pSelectableRow]="item" class="cursor-pointer">
        <td>{{ item.udbyderNavn }}</td>
        <td>{{ item.pengeinstitut?.regnr }}</td>
        <td>{{ item.pensionsInfoUdbyderNavnNr }}</td>
        <td>
          @if (item.p41TilladtFraLeverandoer) {
            <i class="pi pi-check"></i>
          }
        </td>
      </tr>
    </ng-template>
  </p-table>
}
